import { Component, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AranDrawerModalService } from '@aran-client/aran-web-ui-toolkit';
import { tap } from 'rxjs';
import { StoreHelperService } from 'src/app/shared/services/store-helper/store-helper.service';
import {
  ChangePassFormGeneralType,
  ChangePassFormType,
} from 'src/app/shared/types/auth.types';
import { ErrorMessages } from 'src/app/shared/utils/error-message.utils';
import { PasswordUtils } from 'src/app/shared/utils/password.utils';
import { AuthAction } from 'src/app/store/auth/auth.action';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  form!: FormGroup<ChangePassFormType>;
  errorMessages = ErrorMessages;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private aranDrawerModalService: AranDrawerModalService,
    private storeHelperService: StoreHelperService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      oldPassword: this.formBuilder.control(null, Validators.required),
      newPassword: this.formBuilder.control(null, [
        Validators.required,
        PasswordUtils.passwordValidator(),
      ]),
      confirmNewPassword: this.formBuilder.control(null, [
        Validators.required,
        PasswordUtils.passwordCompareValidator('newPassword'),
      ]),
    });

    PasswordUtils.bindPasswordConfirmation(
      this.form,
      'newPassword',
      'confirmNewPassword'
    );
  }

  onEnterPressed(): void {
    this.changePass();
  }

  changePass(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    var body = this.form.value as unknown as ChangePassFormGeneralType;
    const { confirmNewPassword, ...bodyWithoutConfirmPassword } = body;

    this.storeHelperService
      .getAllDispatchAndSelect(
        new AuthAction.ChangePass(bodyWithoutConfirmPassword)
      )
      .pipe(
        tap(() => {
          this.aranDrawerModalService.hide();
        })
      )
      .subscribe();
  }

  get criteriaList() {
    const password = this.form.get('newPassword')?.value || '';
    return PasswordUtils.getCriteria(password);
  }
}
